import cn from 'classnames'
import { NavLink } from 'react-router-dom'

import { Button } from '@src/components/Button/Button'
import { ReactComponent as Error } from '@src/images/error404.svg'
import style from '@src/pages/Errors/Error404.module.scss'

export const Error404 = () => (
  <div className={cn('container', style.containerError404)}>
    <div className={style.errorPage}>
      {Error && <Error />}
      <p>Страница, которую вы ищете, не найдена. Возможно, она была удалена, изменился её адрес, либо страница временно недоступна.</p>
      <NavLink
        to="/lk/profile"
      >
        <Button className={style.btnSize}>Вернуться на главную</Button>
      </NavLink>
    </div>
  </div>
)
